import { z } from 'zod';

const specializationSchema = z.object({
   specialization: z
      .array(z.string())
      .nonempty('Please select at least one specialization')
      .min(1, 'Please select at least one specialization'),
});

export type TSpecialization = z.infer<typeof specializationSchema>;
export { specializationSchema };
